import { render, staticRenderFns } from "./VersionForm.vue?vue&type=template&id=fc74d8c2&scoped=true&"
import script from "./VersionForm.vue?vue&type=script&lang=js&"
export * from "./VersionForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-form.css?vue&type=style&index=0&id=fc74d8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc74d8c2",
  null
  
)

export default component.exports